import React, { FC } from 'react';
import PostPerformanceDemoView from 'app/modules/insights/components/demoViews/PostPerformanceDemoView';
import PagePerformanceDemoView from 'app/modules/insights/components/demoViews/PagePerformanceDemoView';

type Props = {
  view: string;
};

const InsightsDemoView: FC<Props> = ({ view }) => {
  switch (view) {
    case 'page-performance':
      return <PagePerformanceDemoView />;
    case 'posts-performance':
    case 'competition-analysis':
    default:
      return <PostPerformanceDemoView />;
  }
};

export default InsightsDemoView;
